// extracted by mini-css-extract-plugin
export default {"container":"time_container__5zUaX"};